export default __webpack_public_path__ + "static/dairy-free-taste-1-mobile-959ce44d6936b303fc56b3b910f8028f.png";